var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1585 0.0841243C10.4811 -0.0388177 10.8422 0.12299 10.9651 0.445531L11.9469 3.02117C12.0413 3.26894 11.9691 3.54933 11.7668 3.7207C11.5644 3.89207 11.276 3.91711 11.0472 3.78317C10.1531 3.25991 9.11264 2.9598 8.00016 2.9598C4.66344 2.9598 1.9585 5.66475 1.9585 9.00147C1.9585 10.103 2.25269 11.1338 2.76638 12.0218C2.93922 12.3206 2.83712 12.703 2.53833 12.8758C2.23954 13.0486 1.85721 12.9465 1.68437 12.6478C1.06359 11.5746 0.708496 10.3286 0.708496 9.00147C0.708496 4.97439 3.97309 1.7098 8.00016 1.7098C8.78233 1.7098 9.53633 1.83315 10.2434 2.06154L9.7971 0.890744C9.67416 0.568202 9.83597 0.207066 10.1585 0.0841243ZM13.462 5.12713C13.7608 4.95429 14.1431 5.0564 14.316 5.35518C14.9367 6.42833 15.2918 7.67438 15.2918 9.00147C15.2918 13.0285 12.0272 16.2931 8.00016 16.2931C7.21799 16.2931 6.46399 16.1698 5.75694 15.9414L6.20322 17.1122C6.32617 17.4347 6.16436 17.7959 5.84182 17.9188C5.51928 18.0418 5.15814 17.88 5.0352 17.5574L4.05343 14.9818C3.95898 14.734 4.03116 14.4536 4.23351 14.2822C4.43585 14.1109 4.7243 14.0858 4.95315 14.2198C5.84717 14.743 6.88767 15.0431 8.00016 15.0431C11.3369 15.0431 14.0418 12.3382 14.0418 9.00147C14.0418 7.89998 13.7476 6.8691 13.2339 5.98109C13.0611 5.6823 13.1632 5.29997 13.462 5.12713Z",
    fill: "#00535C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.ee6566c7.svg";
export { ForwardRef as ReactComponent };